module.exports = __webpack_public_path__ + "static/media/Selfie-T-01.7bc903c7.png";